/**
 * SunkenConfig — single visible toggle surface for the /sunken URL.
 *
 * /sunken drops you straight into **The Drowned Cathedral** (`sunken_drift`) —
 * the flooded vault where vast skeletal whales (`leviathans`) drift overhead and
 * pale fish (`schoolingMotes`) school between the pillars. It's a focused showcase
 * for the new `sunkenBiome` archetype (the Sunken Whale system), separate from the
 * six-biome /biomes nexus so this one signature vibe gets its own one-click door.
 *
 * Peaceful by default (set in applyModeUrlCoercion for this path): the whole point
 * is to *soak in* the atmosphere — meditative awe + quiet dread — so nothing
 * attacks you. The biome is an interior (no day/night clock; the whales drift the
 * same at every hour).
 *
 * Wiring (mirrors /biomes):
 *   - applyModeUrlCoercion.ts → coerceModeUrl injects ?map=sunken_drift + preset
 *     + forces the session Peaceful flag for this path
 *   - data/levels/sunken_drift.json → the vault geometry (registered in LevelRegistry)
 *   - src/config/atmosphere/presets/sunkenDrift.ts → the atmosphere (via presetForLevel)
 *   - HomeModePicker.tsx → the "Sunken Whales" card navigates here
 */

export const SUNKEN_CONFIG = {
  resetOnLoad: true,
  defaultClass: 'mage' as const,
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,
} as const;
